import AuthService, { IAuthPostPayload } from '@/app/services/auth'
import { ErrorResponse, IApiIndividualResponse } from '@/types/api'
import { ISession } from '@/types/session'
import { useMutation } from 'react-query'

export function useAuthRegister() {
  return useMutation<
    IApiIndividualResponse<ISession>,
    ErrorResponse,
    IAuthPostPayload
  >(
    AuthService.POST_PATH_PASSWORD_LESS_REGISTER,
    AuthService.passwordLessRegister
  )
}
